import { useState } from "react";
import axios from "axios";
import { Lock, Loader2 } from "lucide-react";
import { API, apiError } from "@/lib/reg";

export const PinGate = ({ onToken }) => {
  const [pin, setPin] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!pin.trim()) return setErr("पिन डालें / Enter PIN");
    setBusy(true);
    setErr("");
    try {
      const { data } = await axios.post(`${API}/organizer/login`, { pin });
      sessionStorage.setItem("gpm_org_token", data.token);
      onToken(data.token);
    } catch (e2) {
      setErr(apiError(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="form-card max-w-sm mx-auto p-6 sm:p-8 text-center space-y-4" data-testid="pin-gate-form">
      <span className="brand-mark mx-auto !w-14 !h-14"><Lock size={24} /></span>
      <h1 className="font-hi text-2xl font-bold text-navy">आयोजक पिन</h1>
      <p className="text-sm text-slate-500">Organizer PIN required to view and download player data</p>
      <input type="password" inputMode="numeric" autoComplete="off" maxLength={12} value={pin}
        onChange={(e) => setPin(e.target.value)} placeholder="••••••"
        className={`gp-input text-center text-2xl tracking-[0.5em] ${err ? "bad" : ""}`} data-testid="pin-input" />
      {err && <p className="field-error" data-testid="pin-error">{err}</p>}
      <button type="submit" disabled={busy} className="btn-saffron w-full justify-center" data-testid="pin-submit-btn">
        {busy ? <Loader2 className="animate-spin" size={18} /> : "खोलें · Unlock"}
      </button>
    </form>
  );
};
